import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prod-produce-inventory",
  "use": "icon-prod-produce-inventory-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-prod-produce-inventory\"><path d=\"M110,196.44,35.14,153.22V66.78L110,23.56l74.86,43.22v86.44ZM44.14,148l65.86,38,65.86-38V72L110,34,44.14,72Z\" /><polygon points=\"110 114.74 37.39 72.82 41.89 65.02 110 104.35 178.11 65.02 182.61 72.82 110 114.74\" /><polygon points=\"110 155.34 37.39 113.41 41.89 105.62 110 144.94 178.11 105.62 182.61 113.41 110 155.34\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol